export enum EquipmentsGetters {
    GET_EQUIPMENTS = 'GET_EQUIPMENTS',
    GET_DATACENTERS = 'GET_DATACENTERS',
    GET_PARAMETERS = 'GET_PARAMETERS',
}
